// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

li {
  list-style: none;
}



a,
a:hover {
  text-decoration-line: none !important;
}

body {
  font-family: 'Poppins', sans-serif !important;
}

.active_sidebar {
  overflow: hidden;
}

.App {
  background-color: white;
}

.container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.container.col-md-4 {
  width: 100%;
}

.container.col-md-4 .stats_list.mb-3 {
  width: 23%;
}


/* App.css */
.pagination {
  display: flex;
  list-style: none;
  padding: 0;
}

.pagination li {
  margin: 0 5px;
  cursor: pointer;
}

.pagination .active a {
  font-weight: bold;
  color: #fff;
}

.tattoo-cat {
  margin: 0 2px;
  background: #0a2e2e;
  color: #fff;
  padding: 2px 4px;
  border-radius: 4px;
}

.signIn-btn {
  background: #092e2f !important;
  border-color: #092e2f !important;
}

.dashboard_card .stats_list {
  height: 150px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;AAClB;;;;AAIA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;;AAGA,YAAY;AACZ;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\nli {\n  list-style: none;\n}\n\n\n\na,\na:hover {\n  text-decoration-line: none !important;\n}\n\nbody {\n  font-family: 'Poppins', sans-serif !important;\n}\n\n.active_sidebar {\n  overflow: hidden;\n}\n\n.App {\n  background-color: white;\n}\n\n.container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.container.col-md-4 {\n  width: 100%;\n}\n\n.container.col-md-4 .stats_list.mb-3 {\n  width: 23%;\n}\n\n\n/* App.css */\n.pagination {\n  display: flex;\n  list-style: none;\n  padding: 0;\n}\n\n.pagination li {\n  margin: 0 5px;\n  cursor: pointer;\n}\n\n.pagination .active a {\n  font-weight: bold;\n  color: #fff;\n}\n\n.tattoo-cat {\n  margin: 0 2px;\n  background: #0a2e2e;\n  color: #fff;\n  padding: 2px 4px;\n  border-radius: 4px;\n}\n\n.signIn-btn {\n  background: #092e2f !important;\n  border-color: #092e2f !important;\n}\n\n.dashboard_card .stats_list {\n  height: 150px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
